import { render } from "./RobotComponent.vue?vue&type=template&id=9c03d576&scoped=true"
import script from "./RobotComponent.vue?vue&type=script&lang=js"
export * from "./RobotComponent.vue?vue&type=script&lang=js"

import "./RobotComponent.vue?vue&type=style&index=0&id=9c03d576&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c03d576"]])

export default __exports__